export default "__VITE_ASSET__DRi1RKqq__"